// src/api/employeeLogApi.js
import apiClient from './axios';

const employeeLogApi = {
  // GET all logs with pagination + search
  // getAll: async (page = 1, pageSize = 10, search = '') => {
  //   const response = await apiClient.get('/logs/', {
  //     params: { 
  //       page, 
  //       page_size: pageSize,
  //       search: search.trim() || undefined  // Send only if not empty
  //     },
  //   });
  //   return response.data; // { data: [...], pagination: { ... } }
  // },

  // src/api/employeeLogApi.js  ← Add this line only
getAll: async (page = 1, pageSize = 10, search = '', resource = null) => {
  const response = await apiClient.get('/logs/', {
    params: { 
      page, 
      page_size: pageSize,
      search: search.trim() || undefined,
      resource: resource || undefined  // ← This enables filtering
    },
  });
  return response.data;
},

  getById: async (id) => {
    const response = await apiClient.get(`/logs/${id}/`);
    return response.data;
  },
};

export default employeeLogApi;